import { schema } from 'normalizr';

const channelSchema = new schema.Entity('channels', {});

export default channelSchema;
